/**
 * @flow
 * @relayHash 542ca0f29c315af4cbaaa09a2eec2074
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DeepPagesTable_project$ref = any;
export type FilterOperator = "AND" | "OR" | "%future added value";
export type TextFilterOperator = "CONTAINS" | "NOT_CONTAINS" | "REGEXP" | "%future added value";
export type TextFilters = {
  operator: FilterOperator,
  values?: ?$ReadOnlyArray<?TextFilter>,
};
export type TextFilter = {
  operator: TextFilterOperator,
  value: string,
};
export type DeepPagesTable_RefetchQueryVariables = {|
  offset?: ?number,
  limit?: ?number,
  depthOrder?: ?number,
  sourceUrl?: ?TextFilters,
  errorUrl?: ?TextFilters,
  typeFilters?: ?$ReadOnlyArray<?string>,
  host: string,
|};
export type DeepPagesTable_RefetchQueryResponse = {|
  +project: ?{|
    +$fragmentRefs: DeepPagesTable_project$ref
  |}
|};
export type DeepPagesTable_RefetchQuery = {|
  variables: DeepPagesTable_RefetchQueryVariables,
  response: DeepPagesTable_RefetchQueryResponse,
|};
*/


/*
query DeepPagesTable_RefetchQuery(
  $offset: Int
  $limit: Int
  $depthOrder: Int
  $sourceUrl: TextFilters
  $errorUrl: TextFilters
  $typeFilters: [String]
  $host: String!
) {
  project(host: $host) {
    ...DeepPagesTable_project_f3yf5
    id
  }
}

fragment DeepPagesTable_project_f3yf5 on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countTypesDeepPages(errorUrl: $errorUrl, sourceUrl: $sourceUrl) {
          type
          count
          severity
        }
        deepPages(offset: $offset, limit: $limit, sourceUrl: $sourceUrl, depthOrder: $depthOrder, errorUrl: $errorUrl, typeFilters: $typeFilters) {
          count
          edges {
            node {
              ...DeepPagesRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment DeepPagesRow_issue on DeepPage {
  id
  type
  severity
  depth
  error_url
  source_url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "limit",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "depthOrder",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sourceUrl",
    "type": "TextFilters",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "errorUrl",
    "type": "TextFilters",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "typeFilters",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Variable",
  "name": "errorUrl",
  "variableName": "errorUrl",
  "type": "TextFilters"
},
v3 = {
  "kind": "Variable",
  "name": "sourceUrl",
  "variableName": "sourceUrl",
  "type": "TextFilters"
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "severity",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "DeepPagesTable_RefetchQuery",
  "id": null,
  "text": "query DeepPagesTable_RefetchQuery(\n  $offset: Int\n  $limit: Int\n  $depthOrder: Int\n  $sourceUrl: TextFilters\n  $errorUrl: TextFilters\n  $typeFilters: [String]\n  $host: String!\n) {\n  project(host: $host) {\n    ...DeepPagesTable_project_f3yf5\n    id\n  }\n}\n\nfragment DeepPagesTable_project_f3yf5 on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countTypesDeepPages(errorUrl: $errorUrl, sourceUrl: $sourceUrl) {\n          type\n          count\n          severity\n        }\n        deepPages(offset: $offset, limit: $limit, sourceUrl: $sourceUrl, depthOrder: $depthOrder, errorUrl: $errorUrl, typeFilters: $typeFilters) {\n          count\n          edges {\n            node {\n              ...DeepPagesRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment DeepPagesRow_issue on DeepPage {\n  id\n  type\n  severity\n  depth\n  error_url\n  source_url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "DeepPagesTable_RefetchQuery",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "DeepPagesTable_project",
            "args": [
              {
                "kind": "Variable",
                "name": "depthOrder",
                "variableName": "depthOrder",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "errorUrl",
                "variableName": "errorUrl",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "limit",
                "variableName": "limit",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "offset",
                "variableName": "offset",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "sourceUrl",
                "variableName": "sourceUrl",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "typeFilters",
                "variableName": "typeFilters",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "DeepPagesTable_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countTypesDeepPages",
                        "storageKey": null,
                        "args": [
                          v2,
                          v3
                        ],
                        "concreteType": "CountType",
                        "plural": true,
                        "selections": [
                          v4,
                          v5,
                          v6
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "deepPages",
                        "storageKey": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "depthOrder",
                            "variableName": "depthOrder",
                            "type": "Int"
                          },
                          v2,
                          {
                            "kind": "Variable",
                            "name": "limit",
                            "variableName": "limit",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "offset",
                            "variableName": "offset",
                            "type": "Int"
                          },
                          v3,
                          {
                            "kind": "Variable",
                            "name": "typeFilters",
                            "variableName": "typeFilters",
                            "type": "[String]"
                          }
                        ],
                        "concreteType": "DeepPagesConnection",
                        "plural": false,
                        "selections": [
                          v5,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DeepPagesEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "DeepPage",
                                "plural": false,
                                "selections": [
                                  v7,
                                  v4,
                                  v6,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "depth",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "error_url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v7
                    ]
                  }
                ]
              }
            ]
          },
          v7
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '75f49235ddc95e88d94223169d047950';
module.exports = node;
